const routes = [
    {path: '/*', breadcrumb: 'Home'},
    
    {path: '/profilo', breadcrumb: 'Profilo'},
    {path: '/corsi', breadcrumb: 'Corsi'},
    {path: '/corso/:id/*', breadcrumb: 'Corso'},
    {path: '/corso/:id/pianificazione/inserisci', breadcrumb: 'Pianificazione'},

    {path: '/corso/:id/calendarioFSE/*', breadcrumb: 'Calendario'},
    {path: '/corso/:id/calendarioFSE/:idPianificazione/data/:data/aggiorna', breadcrumb: 'Agg. Pianificazione'},
    {path: '/corso/:id/calendarioSCR/*', breadcrumb: 'Calendario SCR'},
    {path: '/corso/:id/calendarioSCR/:idPianificazione/data/:data/aggiorna', breadcrumb: 'Agg. Pianificazione SCR'},

    {path: '/corso/:id/castelletto', breadcrumb: 'Castelletto', search: {tab: null}},
    {path: '/corso/:id/validazionecorso', breadcrumb: 'Validazione corso'},
    {path: '/corso/:id/monitoraggioValidazione', breadcrumb: 'Monitoraggio validazioni corso'},
    {path: '/corso/:id/schedaCorso', breadcrumb: 'Scheda corso'},

    {path: '/corso/:id/profiliorariFSE', breadcrumb: 'Profili Orari'},
    {path: '/corso/:id/profilazioneFSE', breadcrumb: 'Profilazione'},
    {path: '/corso/:id/profiliorariSCR', breadcrumb: 'Profili Orari SCR'},
    {path: '/corso/:id/profiliorariFSE/dettaglio/:idAnagrafica', breadcrumb: 'DettaglioProfilo'},
    {path: '/corso/:id/profiliorariSCR/dettaglio/:idAnagrafica', breadcrumb: 'DettaglioProfilo SCR'},

    /*
    * per utilizzare in i queryParams dinamici nei bradcrumbs bisogna utilizzare la proprietà
    * 'search' e all'interno indicare un oggetto i cui nomi delle proprietà devono essere uguali al nome o di queryParam
    * già esistenti o ai nomi dei parametri all'interno della url.
    * e.s.
    *   per il registro si vuole rendere dinamico il tab, che è contenuto nei queryParam della rotta di destinazione,
    *   e la data che invece è un parametro all'interno della url di destinazione, in questo caso del RegistroDettaglio.
    *
    * per i fragment invece inseririre la proprietà 'fragment' il cui valore, ad ora, può essere solo una stringa.
    * */
    {path: '/corso/:id/registro/*', breadcrumb: 'Registro', search: {tab: null, data: null}},
    {path: '/corso/:id/registro/:individuo/dettaglio/*', breadcrumb: 'Registro Dettaglio'},
    {path: '/corso/:id/registro/:individuo/dettaglio/ingressomanuale', breadcrumb: 'Ingresso Manuale'},
    {path: '/corso/:id/registro/:individuo/dettaglio/uscitamanuale', breadcrumb: 'Uscita Manuale'},
    {path: '/corso/:id/registro/:individuo/dettaglio/giustificativo/inserisci', breadcrumb: 'Giustificativo'},

    {path: '/corso/:id/studenti/giustificativo/inserisci', breadcrumb: 'Giustificativo'},
    {path: '/corso/:id/presenze/*', breadcrumb: 'Presenze'},
    {path: '/corso/:id/presenze/ingresso', breadcrumb: 'Ingresso'},
    {path: '/corso/:id/presenze/uscita', breadcrumb: 'Uscita'},

    {path: '/inserimentoAnagrafica', breadcrumb: 'Inserimento Anagrafica'},

    {path: '/superAdmin/ricercacorso', breadcrumb: 'Gestione SuperAdmin - RicercaCorso'},
    {path: '/superAdmin/ricercacorso/modificaAllievo/corso/:id', breadcrumb: 'Modifica Allievo'},

    {path: '/superAdmin/tipizzazione', breadcrumb: 'Tipizzazione'},
];


export default routes;
